import { AxiosService } from './axios.service'

const baseURL = 'preco-da-viagem'

/**
 * Defines the API methods for trip price
 */
export default class TripPriceService {
	/**
	 * Get the conversion parameters for trip prices
	 * @return {Promise<any>} The conversion parameters
	 */
	static getConversionParameters() {
		return AxiosService.get(`${baseURL}/parametros-de-conversao`).then(
			({ data }) => data
		)
	}
}
